import { createApi } from '@reduxjs/toolkit/query/react'

import { FeatureType } from 'clickNgo/configs/feature'
import { axiosProcedureQuery } from 'clickNgo/helpers/api'

import { IOffboardingProcessStatus } from '../model/types'

export const mdOffboardingApi = createApi({
  reducerPath: `${FeatureType.P360Api}/mdOffboardingApi`,
  baseQuery: axiosProcedureQuery<any[]>(),
  tagTypes: ['OffboardingStatus'],
  endpoints(build) {
    return {
      getOffboardingProcessPermission: build.query<boolean, string>({
        transformResponse(response: any) {
          if (response?.Rows?.length) {
            const [item] = response.Rows
            return item.Access === 1
          }
          return false
        },
        query(partnerId: string) {
          return {
            url: `/webservice/197/sp/v3/dbo.spJBPUserCheck/call`,
            method: 'POST',
            data: {
              'p.PartnerID': partnerId,
              'p.CheckType': 'MDOffboarding',
            },
          }
        },
      }),

      getOffboardingProcessStatus: build.query<IOffboardingProcessStatus | null, string>({
        providesTags: ['OffboardingStatus'],
        transformResponse(response: any) {
          if (response?.Rows?.length) {
            const [status] = response.Rows
            return status
          }
          return null
        },
        query(partnerId: string) {
          return {
            url: `/webservice/197/sp/v3/JBPMasterDealerMDOffboardingStatus/call`,
            method: 'POST',
            data: {
              'p.PartnerID': partnerId,
            },
          }
        },
      }),

      initOffboardingProcess: build.mutation<IOffboardingProcessStatus | null, string>({
        invalidatesTags: ['OffboardingStatus'],
        transformResponse(response: any) {
          if (response?.Rows?.length) {
            const [status] = response.Rows
            return status
          }
          return null
        },
        query(partnerId: string) {
          return {
            url: `/webservice/197/sp/v3/JBPMasterDealerMDOffboarding/call`,
            method: 'POST',
            data: {
              'p.PartnerID': partnerId,
            },
          }
        },
      }),

      resetMDStatus: build.mutation<void, string>({
        invalidatesTags: ['OffboardingStatus'],
        query(partnerId: string) {
          return {
            url: `/webservice/197/sp/v3/dbo.JBPMasterDealerMDOffboardingTest/call`,
            method: 'POST',
            data: {
              'p.PartnerID': partnerId,
              'p.Case': 1,
            },
          }
        },
      }),
    }
  },
})

export const {
  useGetOffboardingProcessPermissionQuery,
  useGetOffboardingProcessStatusQuery,
  useInitOffboardingProcessMutation,
  useResetMDStatusMutation,
} = mdOffboardingApi
